<template>
<div>
  <div class="container">
    <header class="header">
      <h1 @click="backSite()" v-if="textLogo === 'on'" class="title">{{ $t('organization') }}</h1>
      <img @click="backSite()" v-if="logo != ''" class="logo" :src="logo" alt="logo">
      <div class="lang">
        <router-link
          class="lang__item"
          :class="{ active: $route.params.lang === 'uz' }"
          :to="{name: 'Home', params: { lang: 'uz'}}"
        >
          <img class="img" :src="linkImg+'/img/041-uzbekistan.png'" alt="" />
        </router-link>
        <router-link
          class="lang__item"
          :class="{ active: $route.params.lang === 'ru' }"
          :to="{name: 'Home', params: { lang: 'ru'}}"
        >
          <img class="img" :src="linkImg+'/img/044-russia.png'" alt="" />
        </router-link>
        <router-link
          class="lang__item"
          :class="{ active: $route.params.lang === 'en' }"
          :to="{name: 'Home', params: { lang: 'en'}}"
        >
          <img class="img" :src="linkImg+'/img/186-united-states.png'" alt="" />
        </router-link>
      </div>
    </header>
    <section class="menu">
      <div class="menu__block">
        <a v-if="booking === 'on'" href="" @click.prevent="menuOne" to="" class="item">{{$t('homeBtnOne')}}</a>
        <a v-if="eticket === 'on'" href="" @click.prevent="menuTwo" to="" class="item">{{$t('homeBtnTwo')}}</a>
      </div>
    </section>
  </div>
</div>
</template>

<script>
// import Lang from '@/components/Lang.vue'


export default {
  data() {
    return {
      logo: window.MY_CONFIG_EASYQ.logo,
      textLogo: window.MY_CONFIG_EASYQ.textLogo,
      booking: 'on',
      eticket: 'on',
      site: '',
      deviceId: '',
      linkImg: '',
      lang: ''
    }
  },
  components: {
    // Lang
  },
  computed: {
  },
  beforeMount() {
    this.booking = window.MY_CONFIG_EASYQ.booking;
    this.eticket = window.MY_CONFIG_EASYQ.eticket;
    this.site = window.MY_CONFIG_EASYQ.site;
    this.lang = window.MY_CONFIG_EASYQ.lang;
    this.linkImg = window.MY_CONFIG_EASYQ.linkImg;
    
    const deviceId = localStorage.getItem('deviceId');
    const deviceNumber = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
    if(deviceId == null || deviceId == undefined) {
      localStorage.setItem('deviceId', deviceNumber);
    } else if(deviceId != '') {
      this.deviceId = deviceId;
    } else {
      this.deviceId = deviceNumber;
      localStorage.setItem('deviceId', deviceNumber);
    }
  },
  mounted() {
    if(localStorage.eticket === null || localStorage.eticket === undefined) {
      localStorage.setItem('eticket', JSON.stringify([]));
    }
    if(localStorage.booking === null || localStorage.booking === undefined) {
      localStorage.setItem('booking', JSON.stringify([]));
    }
    // console.log(this.$route.params.lang);
  },
  methods: {
    menuOne() {
      this.$router.push({ name: 'Search', params: { lang: this.$route.params.lang, metod: 'booking' }});
      localStorage.name = 1;
    },
    menuTwo() {
      this.$router.push({ name: 'Search', params: { lang: this.$route.params.lang, metod: 'e-ticket' }});
      localStorage.name = 2;
    },
    backSite() {
      window.location = this.site;
    }
  },
  created() {
    this.$i18n.locale = this.$route.params.lang;
  },
  watch: {
    '$route.params.lang'() {
      this.$i18n.locale = this.$route.params.lang;
    }
  }
}
</script>

<style lang="scss">
.header {
  .title {
    cursor: pointer;
  }
}
.logo {
  cursor: pointer;
  max-width: 160px;
  width: 100%;
}
.lang__item {
  cursor: pointer;
}
.error {
  position: absolute;
  top: 0;
  left: 0;
}
</style>